export default __webpack_public_path__ + "static/media/047-grandfather.fae3c6df.png";